/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Createfirsttitle3Inputs */

const zh_organizationsettings_createfirsttitle3 = /** @type {(inputs: Organizationsettings_Createfirsttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建你的第一个组织`)
};

const en_organizationsettings_createfirsttitle3 = /** @type {(inputs: Organizationsettings_Createfirsttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first organization`)
};

const es_organizationsettings_createfirsttitle3 = /** @type {(inputs: Organizationsettings_Createfirsttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu primera organización`)
};

/**
* | output |
* | --- |
* | "Create your first organization" |
*
* @param {Organizationsettings_Createfirsttitle3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_createfirsttitle3 = /** @type {((inputs?: Organizationsettings_Createfirsttitle3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Createfirsttitle3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_createfirsttitle3(inputs)
	if (locale === "en") return en_organizationsettings_createfirsttitle3(inputs)
	return es_organizationsettings_createfirsttitle3(inputs)
});
export { organizationsettings_createfirsttitle3 as "organizationSettings_createFirstTitle" }